'use client';

import { ReactNode, createContext, useState } from 'react';

import Toast from '@/app/components/Toast/Toast';

interface ToastProviderProps {
  children: ReactNode;
}

export interface ToastType {
  type: 'success' | 'error' | 'warning';
  message: string;
  timeout?: number;
}

type Dispatch<A> = (value: A) => void;
type SetStateAction<S> = S | ((prevState: S) => S);

export const ToastContext = createContext<{
  toast: ToastType | null;
  setToast: Dispatch<SetStateAction<ToastType | null>>;
}>({
  toast: null,
  setToast: () => {},
});

const ToastProvider = ({ children }: ToastProviderProps) => {
  const [toast, setToast] = useState<ToastType | null>(null);

  return (
    <ToastContext.Provider value={{ toast, setToast }}>
      {children}
      <Toast toast={toast} />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
